module.exports = __webpack_public_path__ + "static/media/07-cht.7f36a783.png";